/**
 * Проверяет, истек ли JWT токен
 * @param {string} token JWT токен
 * @returns {boolean} true если токен истек, false если токен еще валиден
 */
export function isTokenExpired(token) {
  if (!token) return true;
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return true;
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const payload = JSON.parse(atob(padded));
    if (!payload.exp) return false; // если нет exp, не проверяем
    const expirationTime = payload.exp * 1000; // exp в секундах, конвертируем в миллисекунды
    return Date.now() > expirationTime;
  } catch (e) {
    console.error('Ошибка при проверке токена:', e);
    return true; // если не удалось декодировать, считаем токен истекшим
  }
}

/**
 * Проверяет валиден ли токен (существует и не истек)
 * @param {string} token JWT токен
 * @returns {boolean} true если токен валиден
 */
export function isTokenValid(token) {
  return token && !isTokenExpired(token);
}

/**
 * Удаляет все данные авторизации из localStorage
 */
export function clearAuthData() {
  localStorage.removeItem('authToken');
  localStorage.removeItem('authUser');
}
